"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
require("./CenteredPage.css");
function CenteredPage(_a) {
    var { children } = _a, props = __rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ id: "centered-page" }, props, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "content" }, { children: children })) })));
}
exports.default = CenteredPage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2VudGVyZWRQYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvc2hhcmVkL0NlbnRlcmVkUGFnZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7QUFDQSw4QkFBNEI7QUFPNUIsU0FBd0IsWUFBWSxDQUFDLEVBR2hCO1FBSGdCLEVBQ25DLFFBQVEsT0FFVyxFQURoQixLQUFLLGNBRjJCLFlBR3BDLENBRFM7SUFFUixPQUFPLENBQ0wsOENBQUssRUFBRSxFQUFDLGVBQWUsSUFBSyxLQUFLLGNBQy9CLCtDQUFNLFNBQVMsRUFBQyxTQUFTLGdCQUFFLFFBQVEsSUFBUSxJQUN2QyxDQUNQLENBQUM7QUFDSixDQUFDO0FBVEQsK0JBU0MifQ==